<div class="row">
    <div class="col-12">
        <div class="form-group">
            <label for="codice">CODICE LINGUA</label>
            <input class="form-control" id="codice" type="text" name="codice_lingua" [(ngModel)]="codiceLingua" />
            <label for="traduzione">TRADUZIONE (json)</label>
            <textarea id="traduzione" class="form-control" [(ngModel)]="translation"></textarea>
        </div>
        <button class="btn btn-primary" (click)="updateLanguage()">Salva</button>
    </div>
</div>